import { ActionHandler } from "../index";
import { queryAssessmentPrivacyPolicy } from "src/api/assessmentPrivacyPolicy";
import { HealthMetricSource, Policy } from "gql/graphql";
import { trackEvent } from "src/utils/api/tracker";
import {
  setAssessmentPrivacyPolicy,
  setAssessmentPrivacyPolicyError,
} from "src/utils/redux/slices/assessmentPrivacyPolicy";

let pendingPrivacyPolicyPromise: Promise<Policy | null> | null = null;

/**
 * Initiates loading of assessment privacy policy without blocking.
 * The actual GraphQL query runs asynchronously to avoid blocking page animations.
 */
export const loadAssessmentPrivacyPolicy: ActionHandler = ({ store }) => {
  // Start the async query and store the promise for later awaiting
  pendingPrivacyPolicyPromise = queryAssessmentPrivacyPolicy(
    HealthMetricSource.FacialBloodScan
  )
    .then((result) => {
      if (result) {
        // Store the privacy policy type in Redux state
        store.dispatch(
          setAssessmentPrivacyPolicy({
            privacyPolicyType: result,
            error: undefined,
          })
        );

        trackEvent("OnAssessmentPrivacyPolicySuccess", {
          privacyPolicyType: result,
          accessCode: store.getState().userData.access_code,
        });
      } else {
        // null result means there was an error in the query call
        store.dispatch(
          setAssessmentPrivacyPolicyError("Privacy policy type not available")
        );
      }
      return result;
    })
    .finally(() => {
      // Clear the promise reference after completion
      pendingPrivacyPolicyPromise = null;
    });
};

/**
 * Waits for the pending privacy policy query to complete (if any).
 * This should be called before pages that require the privacy policy type,
 * such as the privacy policy page.
 */
export const waitForAssessmentPrivacyPolicy: ActionHandler = async () => {
  if (pendingPrivacyPolicyPromise) {
    await pendingPrivacyPolicyPromise;
  }
};
